import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, {FormBody, FormActions, TextInput, ColorInput} from '../../../Form';

@inject('workOrderStatusStore')
@observer
class WOStatusEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/work_order_status';
  title = 'Edit Work Order Status';

  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  constructor(props) {
    super(props);

    const {params: {id}, workOrderStatusStore} = props;

    workOrderStatusStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  @action reset() {
    const {params: {id}, workOrderStatusStore} = this.props;
    const foundItem = workOrderStatusStore.findById(id);
    if (foundItem) {
      this.item = foundItem.asJson;
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const {workOrderStatusStore} = this.props;
    workOrderStatusStore
      .updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const {workOrderStatusStore, params: {id}} = this.props;

    if (workOrderStatusStore.isLoading) {
      return <Spinner/>;
    }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={workOrderStatusStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default WOStatusEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/WorkOrderStatus/WOStatusEdit.js